import { render, staticRenderFns } from "./DevLayoutIcons.vue?vue&type=template&id=6e4751b4&scoped=true"
import script from "./DevLayoutIcons.vue?vue&type=script&lang=ts"
export * from "./DevLayoutIcons.vue?vue&type=script&lang=ts"
import style0 from "./DevLayoutIcons.vue?vue&type=style&index=0&id=6e4751b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4751b4",
  null
  
)

export default component.exports